import React from 'react';
import type { PatientRecord } from '../../patients/types';
import type { TpPatientTreatmentBundle } from '../../patient-treatment/types';
import { PatientTreatmentApproach } from './PatientTreatmentApproach';
import { PatientTreatmentFooter } from './PatientTreatmentFooter';
import { PatientTreatmentObjections } from './PatientTreatmentObjections';
import { PatientTreatmentPatterns } from './PatientTreatmentPatterns';
import { PatientTreatmentQuickRead } from './PatientTreatmentQuickRead';
import { PatientTreatmentSellSequence } from './PatientTreatmentSellSequence';
import { PatientTreatmentStrip } from './PatientTreatmentStrip';
import { TcCheatSheetRail } from './TcCheatSheetRail';

export interface PatientTreatmentTabContentProps {
  patient: PatientRecord;
  bundle: TpPatientTreatmentBundle;
  /** Amendment 27 §7 — the plan-page + call actions in the right rail. */
  onLogCall?: () => void;
  onPreviewPlan?: () => void;
  /** Spec 48 §3.1 — show the "Needs a choice" row (demo: ?choice=1). */
  needsChoice?: boolean;
}

export function PatientTreatmentTabContent({ patient, bundle, onLogCall, onPreviewPlan, needsChoice }: PatientTreatmentTabContentProps) {
  return (
    // The cheat sheet keeps the main column; the four new TC cards sit in a 400px
    // right rail (§7).
    <div className="tc-rise mx-auto flex w-full max-w-[1320px] items-start gap-6 max-[1200px]:flex-col">
      <div className="min-w-0 flex-1">
        <PatientTreatmentStrip patient={patient} context={bundle.context} treatments={bundle.treatments} />
        <PatientTreatmentApproach approach={bundle.approach} />
        <PatientTreatmentQuickRead rows={bundle.quickRead} />
        <PatientTreatmentSellSequence treatments={bundle.treatments} />
        <PatientTreatmentObjections objections={bundle.objections} />
        <PatientTreatmentPatterns
          worked={bundle.worked}
          didntWork={bundle.didntWork}
          takeaway={bundle.patternTakeaway}
        />
        <PatientTreatmentFooter />
      </div>
      <TcCheatSheetRail
        {...(onLogCall ? { onLogCall } : {})}
        {...(onPreviewPlan ? { onPreviewPlan } : {})}
        {...(needsChoice === true ? { needsChoice: true } : {})}
      />
    </div>
  );
}
